'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.upsertDocumentSaga = upsertDocumentSaga;

var _effects = require('redux-saga/effects');

var _getBase = require('../../helpers/getBase64');

var _selectSession = require('../../selectors/context/selectSession');

var _reduceOperation = require('../../actions/context/reduceOperation');

var _reduceOperation2 = _interopRequireDefault(_reduceOperation);

var _reduceLoading = require('../../actions/context/reduceLoading');

var _reduceLoading2 = _interopRequireDefault(_reduceLoading);

var _queryDocumentsSaga = require('./queryDocumentsSaga');

var _selectSubfolderPrefix = require('../../selectors/context/selectSubfolderPrefix');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(upsertDocumentSaga);

function upsertDocumentSaga(action) {
	var session, subfolderPrefix, _action$payload, entity, type, file, encoded, some, request, response, result;

	return regeneratorRuntime.wrap(function upsertDocumentSaga$(_context) {
		while (1) {
			switch (_context.prev = _context.next) {
				case 0:
					_context.next = 2;
					return (0, _effects.put)((0, _reduceLoading2.default)(true));

				case 2:
					_context.next = 4;
					return (0, _effects.select)((0, _selectSession.selectSession)());

				case 4:
					session = _context.sent;
					_context.next = 7;
					return (0, _effects.select)((0, _selectSubfolderPrefix.selectSubfolderPrefix)());

				case 7:
					subfolderPrefix = _context.sent;
					_action$payload = action.payload, entity = _action$payload.entity, type = _action$payload.type, file = _action$payload.file;
					encoded = void 0;
					_context.next = 12;
					return (0, _getBase.getBase64)(file).then(function (data) {
						encoded = data;
					});

				case 12:
					some = _context.sent;


					encoded = encoded.split(',', 2)[1];
					request = {
						document: {
							displayName: file.name.replace('.pdf', ''),
							fileName: file.name,
							type: type,
							contentType: 'pdf',
							source: 'user',
							relatedEntity: entity,
							owner: session.partyGuid,
							status: 'active',
							content: encoded,
							templateCode: type,
							relatedEntityType: 'policyTransaction'
						}
					};
					_context.next = 17;
					return (0, _effects.call)(fetch, subfolderPrefix + '/api/document/upsert', {
						method: 'POST',
						credentials: 'same-origin',
						headers: {
							'Accept': 'application/json',
							'Authorization': session.authenticationToken.token,
							'Content-Type': 'application/json'
						},
						body: JSON.stringify(request)
					});

				case 17:
					response = _context.sent;
					_context.next = 20;
					return (0, _effects.call)([response, 'json']);

				case 20:
					result = _context.sent;
					_context.next = 23;
					return (0, _effects.put)((0, _reduceOperation2.default)(result.operation));

				case 23:
					_context.next = 25;
					return (0, _queryDocumentsSaga.queryDocumentsSaga)();

				case 25:
					_context.next = 27;
					return (0, _effects.put)((0, _reduceLoading2.default)(false));

				case 27:
				case 'end':
					return _context.stop();
			}
		}
	}, _marked, this);
}